import { extractFileNameFromKey } from 'src/app/shared/lib/helpers';
import { environment } from 'src/environments/environment';

import { FileStorageAdapter } from '../models/multimedia-file-api.models';

const apiBaseUrl = `${environment.financialsApi}/api/v1`;

/**
 * @description Implementa un adaptador de almacenamiento de archivos específico para los archivos relacionados con los registros de compra (registro-compra), proporcionando las URLs necesarias para listar, obtener, cargar y eliminar archivos, así como la lógica para construir la carga útil de las operaciones de carga y resolver las claves, IDs y nombres de los archivos remotos.
 * - Este adaptador facilita la integración con el backend para la gestión de archivos multimedia relacionados con los registros de compra, asegurando que las operaciones de carga, descarga y eliminación de archivos se realicen de manera consistente y eficiente.
 */
export const purchaseRecordFilesAdapter: FileStorageAdapter = {
  scope: 'registro-compra',
  listFilesUrl: (owner) => `${apiBaseUrl}/getFilesRC/${owner.entityId}`,
  getFileUrl: (_, remoteFile) => `${apiBaseUrl}/getFileRC/${remoteFile.Key}`,
  uploadUrl: () => `${apiBaseUrl}/addFileRC`,
  deleteFileUrl: (_, file) => `${apiBaseUrl}/deleteFileRC/${file.key}`,
  buildUploadPayload: ({ owner, file }) => ({
    data: file.src,
    rcId: owner.entityId,
    fileName: file.name,
    uploadedBy: file.uploadedBy,
  }),
  resolveRemoteKey: (remoteFile) => remoteFile.Key,
  resolveRemoteId: (remoteFile) => remoteFile.Key,
  resolveRemoteName: (remoteFile) => extractFileNameFromKey(remoteFile.Key ?? ''),
};
